import { render, staticRenderFns } from "./SeriesGroupsTbl.vue?vue&type=template&id=5008a95e&scoped=true&"
import script from "./SeriesGroupsTbl.vue?vue&type=script&lang=js&"
export * from "./SeriesGroupsTbl.vue?vue&type=script&lang=js&"
import style0 from "./SeriesGroupsTbl.vue?vue&type=style&index=0&id=5008a95e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008a95e",
  null
  
)

export default component.exports